// your.component.ts or your.service.ts
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { catchError, switchMap, throwError } from "rxjs";
import { environment } from "../../environments/environment.onprem";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private baseUrl = environment.envVar.baseurl;

  constructor(
    private http: HttpClient,
    private router: Router
  ) {
  }

  postCodeLogin(code: string, codeVerifier: string, redirectUri: string) {
    let params = new HttpParams();
    params = params.set("code", code);
    params = params.set("codeVerifier", codeVerifier);
    params = params.set("redirectUri", redirectUri);

    return this.http.post(
      `${this.baseUrl}/v1/users/login`,
      {},
      {
        params: params,
      }
    );
  }

  postData(userName: string, makeAdminValue: string, loginAdminValue: string,refreshToken: string,
    isError: boolean) {
    const accessToken:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToken : refreshToken}`
    );
    // Define the payload
    const payload = {
      accountName: userName,
      loginAccess: loginAdminValue, 
      loginSA: makeAdminValue,
    };

    // Send the POST request with the payload and headers
    return this.http.post(`${this.baseUrl}/v1/users`, payload, {
      headers: headers,
    });
  }
  postLogin(accessToken: string, email: string) {
    const headers = new HttpHeaders().set(
      "x-access-token",
      `Bearer ${accessToken}`
    );
    const refreshHeader = new HttpHeaders()
    .set('x-refresh-token', `${accessToken}`);
    let params = new HttpParams().set("email", email);
    return this.http
      .post(`${this.baseUrl}/v1/users/login`, null, {
        headers: headers,
        params: params,
      })
      .pipe(
        catchError((error) => {
          // Check if the error status is 401 (Unauthorized)
          if (error.status === 401) {
            // If Unauthorized, attempt token refreshing
            return this.refreshToken(accessToken).pipe(
              switchMap(() => {
                // After refreshing, retry the original request
                return this.http.get(`${this.baseUrl}/v1/users/refreshToken`, {
                  headers: refreshHeader
                });
              }),
              catchError((refreshError) => {
                if (error.status == 403) {
                  this.redirectLogout();
                }
                // Handle error if token refreshing fails
                return throwError(() => refreshError);
              })
            );
          }
          // If the error status is not 401, throw the error
          return throwError(() => {
            const newError = new Error("Your error message here");
            return newError;
          });
        })
      );
  }

  refreshToken(accessToken: string) {
    const refreshHeader = new HttpHeaders()
      .set('x-refresh-token', `${accessToken}`);
      
    // Implement logic to request a new access token using the refresh token
    return this.http.get(`${this.baseUrl}/v1/users/refreshToken`, {
      headers: refreshHeader
    });
  }

  fetchTransaction(
    fromDate: string,
    toDate: string,
    page: number,
    size: number,
    sortField: string,
    sortType: string,
    refreshToken: string,
    isError: boolean
  ) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }
    if (toDate) {
      params = params.set("toDate", toDate);
    }
    if (page) {
      params = params.set("page", page);
    }
    if (size) {
      params = params.set("size", size);
    }
    if (sortField) {
      params = params.set("sortField", sortField);
    }
    if (sortType) {
      params = params.set("orderBy", sortType);
    }

    return this.http.get(`${this.baseUrl}/v1/transaction`, {
      headers: headers,
      params: params,
    });
  }
  getIncrementalTransaction(
    Page: string,
    size: string,
    sortField: string,
    sortType: string,
    refreshToken: string,
    isError: boolean
  ) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (Page) {
      params = params.set("page", Page);
    }
    if (size) {
      params = params.set("size", size);
    }
    if (sortField) {
      params = params.set("sortField", sortField);
    }
    if (sortType) {
      params = params.set("orderBy", sortType);
    }
    return this.http.get(`${this.baseUrl}/v1/transaction/incremental`, {
      headers: headers,
      params: params,
    });
  }
  getdownloadTransaction(
    fromDate: string,
    toDate: string,
    sortField: string,
    sortType: string,
    refreshToken: string,
    isError: boolean
  ) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }
    if (toDate) {
      params = params.set("toDate", toDate);
    }
    if (sortField) {
      params = params.set("sortField", sortField);
    }
    if (sortType) {
      params = params.set("sortType", sortType);
    }
    return this.http.get(`${this.baseUrl}/v1/download/transaction`, {
      headers: headers,
      params: params,
      responseType: "blob",
    });
  }

  getdownloadIncrementalTransaction(refreshToken: string,
    isError: boolean) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    return this.http.get(`${this.baseUrl}/v1/download/incremental`, {
      headers: headers,
      responseType: "blob",
    });
  }

  getAudit(
    fromDate: string,
    toDate: string,
    page: number,
    size: number,
    sortField: string,
    sortType: string,
    refreshToken: string,
    isError: boolean
  ) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }
    if (toDate) {
      params = params.set("toDate", toDate);
    }
    if (page) {
      params = params.set("page", page);
    }

    if (size) {
      params = params.set("size", size);
    }
    if (sortField) {
      params = params.set("sortField", sortField);
    }
    if (sortType) {
      params = params.set("sortType", sortType);
    }

    return this.http.get(`${this.baseUrl}/v1/auditLog`, {
      headers: headers,
      params: params,
    });
  }
  getUser(page: number, size: number, sortField: string, sortType: string, refreshToken: string,
    isError: boolean) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (page) {
      params = params.set("page", page);
    }
    if (size) {
      params = params.set("size", size);
    }
    if (sortField) {
      params = params.set("sortField", sortField);
    }
    if (sortType) {
      params = params.set("sortType", sortType);
    }

    return this.http.get(`${this.baseUrl}/v1/users`, {
      headers: headers,
      params: params,
    });
  }


  getUserTable(page: number, size: number,refreshToken: string,
    isError: boolean) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (size) {
      params = params.set("size", size);
    }
    if (page) {
      params = params.set("page", page);
    }
   
    return this.http.get(`${this.baseUrl}/v1/users`, {
      headers: headers,
      params: params,
    });
  }

  getUsers(searchQuery: string, refreshToken: string,
    isError: boolean) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (searchQuery) {
      params = params.set("email", searchQuery);
    }

    return this.http.get(`${this.baseUrl}/v1/users/search`, {
      headers: headers,
      params: params,
    });
  }
  getdownloadAudit(
    fromDate: string,
    toDate: string,
    sortField: string,
    sortType: string,
    refreshToken: string,
    isError: boolean
  ) {
    const accessToke:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToke : refreshToken}`
    );
    let params = new HttpParams();
    if (fromDate) {
      params = params.set("fromDate", fromDate);
    }
    if (toDate) {
      params = params.set("toDate", toDate);
    }
    if (sortField) {
      params = params.set("sortField", sortField);
    }
    if (sortType) {
      params = params.set("sortType", sortType);
    }
    return this.http.get(`${this.baseUrl}/v1/download/auditLog`, {
      headers: headers,
      params: params,
      responseType: "blob",
    });
  }
  showUserList(refreshToken: string,
    isError: boolean) {
    const accessToken:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToken : refreshToken}`
    );

    // Return the POST request with the correct headers and parameters
    return this.http.post(
      `${this.baseUrl}/v1/users/search-user-account`,
      {},
      {
        headers: headers,
      }
    );
  }
  editData(data: any, makeAdminValue: string, loginAdminValue: string,refreshToken: string,
    isError: boolean) {
    const accessToken:any = sessionStorage.getItem("accessToken");
    const headers = new HttpHeaders().set(
      "Authorization",
      `Bearer ${!isError ? accessToken : refreshToken}`
    );
    // Define the payload
    const payload = {
      accountName: data.account_name,
      loginAccess: loginAdminValue,
      loginSA: makeAdminValue,
    };

    // Send the POST request with the payload and headers
    return this.http.put(`${this.baseUrl}/v1/users`, payload, {
      headers: headers,
    });
  }

  redirectLogout() {
    sessionStorage.removeItem("isSeenWelcome");
    sessionStorage.removeItem("accessToken");
    sessionStorage.clear();
    this.router.navigate(["/"]);
  }
}
